import { AfterViewInit, Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { fromEvent } from "rxjs";
import { CommonService } from "src/app/common.service";

@Component({
  selector: "app-online-offline-dialog",
  templateUrl: "./online-offline-dialog.component.html",
  styleUrls: ["./online-offline-dialog.component.scss"],
})
export class OnlineOfflineDialogComponent implements OnInit, AfterViewInit {

  constructor(protected _commonService: CommonService,private dialogRef: MatDialogRef<OnlineOfflineDialogComponent>) {}
  
  ngAfterViewInit(): void {
  }

  ngOnInit(): void {}

  close() {
    this.dialogRef.close(1);
  }
}
